import { sanitizeInternalRedirect } from '../utils/safeRedirect'
import { defaultBrandFromHostname, parseHostnameFromEnv } from './brandFromHost'

export function getAiClaimsPortalHostname(): string {
  return parseHostnameFromEnv(process.env.NEXT_PUBLIC_AICLAIMS_PORTAL_HOST)
}

export function shouldUseSessionHandoff(
  targetBrand: 'wysehub' | 'aiclaims',
): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const currentBrand = defaultBrandFromHostname(
    window.location.hostname,
    process.env.NEXT_PUBLIC_AICLAIMS_HOST,
    process.env.NEXT_PUBLIC_AICLAIMS_PORTAL_HOST,
  )
  return currentBrand !== targetBrand
}

export function buildSessionHandoffUrl(
  brand: 'wysehub' | 'aiclaims',
  nextPath: string,
): string {
  const defaultNext = brand === 'aiclaims' ? '/aiclaims/welcome' : '/homehub'
  const origin =
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
  const safeNext = sanitizeInternalRedirect(nextPath, origin) ?? defaultNext
  const params = new URLSearchParams({ brand, next: safeNext })
  return `/api/v1/login/session-handoff/start?${params.toString()}`
}

export function navigateToBrandPortal(
  brand: 'wysehub' | 'aiclaims',
  nextPath: string,
  sameHostNavigate: () => void,
): void {
  if (shouldUseSessionHandoff(brand)) {
    window.location.href = buildSessionHandoffUrl(brand, nextPath)
    return
  }

  sameHostNavigate()
}

export function resolveAllowedHomePath(
  brandAccess?: string | null,
): '/homehub' | '/aiclaims/welcome' {
  if (brandAccess === 'aiclaims') {
    return '/aiclaims/welcome'
  }
  return '/homehub'
}
